import {createPortal} from "react-dom";
import {css} from "@panda/css";
import {AnimatePresence, motion} from "framer-motion";

import {CloseIcon} from "@pg-design/icons-module";

import {useAppDispatch, useAppSelector} from "../../../store/hooks";
import {closeAuthDrawer} from "../../state/semantic_search_auth_slice";
import {SemanticSearchAuthLoginForm} from "./SemanticSearchAuthLoginForm";
import {SemanticSearchAuthPhoneVerificationForm} from "./SemanticSearchAuthPhoneVerificationForm";
import {SemanticSearchAuthSignupForm} from "./SemanticSearchAuthSignupForm";

const INLINE_Z = 10;

const PORTAL_DEFAULT_BACKDROP_Z = 10050;

export interface SemanticSearchAuthOverlayProps {
    /**
     * Use this when the overlay should appear above everything else,
     * for example when it is opened from inside another modal.
     * Without it, the overlay stays inside its parent container,
     * which is useful for cases like the semantic search sidebar.
     */
    usePortal?: boolean;
}

export const SemanticSearchAuthOverlay = ({usePortal = false}: SemanticSearchAuthOverlayProps = {}) => {
    const dispatch = useAppDispatch();
    const step = useAppSelector((state) => state.semanticSearchAuth.activeDrawer);

    const portalBackdropZIndex = PORTAL_DEFAULT_BACKDROP_Z;
    const portalDrawerZIndex = PORTAL_DEFAULT_BACKDROP_Z + 1;

    const handleClose = () => {
        dispatch(closeAuthDrawer());
    };

    const overlay = step && (
        <>
            <motion.div
                className={usePortal ? overlayPortaled : overlayInline}
                style={usePortal ? {zIndex: portalBackdropZIndex} : undefined}
                onClick={handleClose}
                initial={{opacity: 0}}
                animate={{opacity: 0.75}}
                exit={{opacity: 0}}
                transition={{duration: 0.3}}
            />
            <motion.div
                className={usePortal ? drawerPortaled : drawerInline}
                style={usePortal ? {zIndex: portalDrawerZIndex} : undefined}
                initial={{y: "100%"}}
                animate={{y: 0}}
                exit={{y: "100%"}}
                transition={{type: "tween", duration: 0.25, ease: "easeOut"}}
            >
                <button type="button" className={closeButtonStyle} onClick={handleClose}>
                    <CloseIcon size="1.6" />
                </button>

                <div className={content}>
                    {step === "login" && <SemanticSearchAuthLoginForm />}
                    {step === "signup" && <SemanticSearchAuthSignupForm />}
                    {step === "phone_verification" && <SemanticSearchAuthPhoneVerificationForm />}
                </div>
            </motion.div>
        </>
    );

    const tree = <AnimatePresence>{overlay}</AnimatePresence>;

    if (!usePortal) {
        return tree;
    }

    if (typeof document === "undefined") {
        return null;
    }

    return createPortal(tree, document.body);
};

const overlayInline = css({
    position: "absolute",
    inset: 0,
    backgroundColor: "var(--colors-secondary)",
    zIndex: INLINE_Z
});

const drawerInline = css({
    position: "absolute",
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "var(--colors-white)",
    borderTopLeftRadius: 2,
    borderTopRightRadius: 2,
    maxHeight: "90%",
    display: "flex",
    flexDirection: "column",
    boxShadow: "var(--shadow-2)",
    zIndex: INLINE_Z
});

const overlayPortaled = css({
    position: "fixed",
    inset: 0,
    backgroundColor: "var(--colors-secondary)"
});

const drawerPortaled = css({
    position: "fixed",
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "var(--colors-white)",
    borderTopLeftRadius: 2,
    borderTopRightRadius: 2,
    maxHeight: "90dvh",
    display: "flex",
    flexDirection: "column",
    boxShadow: "var(--shadow-2)"
});

const closeButtonStyle = css({
    position: "absolute",
    top: 2,
    right: 2,
    zIndex: 10,
    backgroundColor: "var(--colors-white)",
    borderRadius: "50%",
    width: "calc(4 * var(--globals-baseUnit))",
    height: "calc(4 * var(--globals-baseUnit))",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "var(--shadow-2)",
    cursor: "pointer",

    "&:hover": {
        backgroundColor: "var(--colors-gray-100)"
    }
});

const content = css({
    padding: 4,
    overflowY: "auto",
    flex: 1
});
import {createPortal} from "react-dom";
import {css} from "@panda/css";
import {AnimatePresence, motion} from "framer-motion";

import {CloseIcon} from "@pg-design/icons-module";

import {useAppDispatch, useAppSelector} from "../../../store/hooks";
import {closeAuthDrawer} from "../../state/semantic_search_auth_slice";
import {SemanticSearchAuthLoginForm} from "./SemanticSearchAuthLoginForm";
import {SemanticSearchAuthPhoneVerificationForm} from "./SemanticSearchAuthPhoneVerificationForm";
import {SemanticSearchAuthSignupForm} from "./SemanticSearchAuthSignupForm";

const INLINE_Z = 10;

const PORTAL_DEFAULT_BACKDROP_Z = 10050;

export interface SemanticSearchAuthOverlayProps {
    /**
     * Use this when the overlay should appear above everything else,
     * for example when it is opened from inside another modal.
     * Without it, the overlay stays inside its parent container,
     * which is useful for cases like the semantic search sidebar.
     */
    usePortal?: boolean;
}

export const SemanticSearchAuthOverlay = ({usePortal = false}: SemanticSearchAuthOverlayProps = {}) => {
    const dispatch = useAppDispatch();
    const step = useAppSelector((state) => state.semanticSearchAuth.activeDrawer);

    const portalBackdropZIndex = PORTAL_DEFAULT_BACKDROP_Z;
    const portalDrawerZIndex = PORTAL_DEFAULT_BACKDROP_Z + 1;

    const handleClose = () => {
        dispatch(closeAuthDrawer());
    };

    const overlay = step && (
        <>
            <motion.div
                className={usePortal ? overlayPortaled : overlayInline}
                style={usePortal ? {zIndex: portalBackdropZIndex} : undefined}
                onClick={handleClose}
                initial={{opacity: 0}}
                animate={{opacity: 0.75}}
                exit={{opacity: 0}}
                transition={{duration: 0.3}}
            />
            <motion.div
                className={usePortal ? drawerPortaled : drawerInline}
                style={usePortal ? {zIndex: portalDrawerZIndex} : undefined}
                initial={{y: "100%"}}
                animate={{y: 0}}
                exit={{y: "100%"}}
                transition={{type: "tween", duration: 0.25, ease: "easeOut"}}
            >
                <button type="button" className={closeButtonStyle} onClick={handleClose}>
                    <CloseIcon size="1.6" />
                </button>

                <div className={content}>
                    {step === "login" && <SemanticSearchAuthLoginForm />}
                    {step === "signup" && <SemanticSearchAuthSignupForm />}
                    {step === "phone_verification" && <SemanticSearchAuthPhoneVerificationForm />}
                </div>
            </motion.div>
        </>
    );

    const tree = <AnimatePresence>{overlay}</AnimatePresence>;

    if (!usePortal) {
        return tree;
    }

    if (typeof document === "undefined") {
        return null;
    }

    return createPortal(tree, document.body);
};

const overlayInline = css({
    position: "absolute",
    inset: 0,
    backgroundColor: "var(--colors-secondary)",
    zIndex: INLINE_Z
});

const drawerInline = css({
    position: "absolute",
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "var(--colors-white)",
    borderTopLeftRadius: 2,
    borderTopRightRadius: 2,
    maxHeight: "90%",
    display: "flex",
    flexDirection: "column",
    boxShadow: "var(--shadow-2)",
    zIndex: INLINE_Z
});

const overlayPortaled = css({
    position: "fixed",
    inset: 0,
    backgroundColor: "var(--colors-secondary)"
});

const drawerPortaled = css({
    position: "fixed",
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "var(--colors-white)",
    borderTopLeftRadius: 2,
    borderTopRightRadius: 2,
    maxHeight: "90dvh",
    display: "flex",
    flexDirection: "column",
    boxShadow: "var(--shadow-2)"
});

const closeButtonStyle = css({
    position: "absolute",
    top: 2,
    right: 2,
    zIndex: 10,
    backgroundColor: "var(--colors-white)",
    borderRadius: "50%",
    width: "calc(4 * var(--globals-baseUnit))",
    height: "calc(4 * var(--globals-baseUnit))",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "var(--shadow-2)",
    cursor: "pointer",

    "&:hover": {
        backgroundColor: "var(--colors-gray-100)"
    }
});

const content = css({
    padding: 4,
    overflowY: "auto",
    flex: 1
});
